var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.component,{tag:"component",class:[
    _vm.$style.root,
    ( _obj = {}, _obj[_vm.$style.selected] = _vm.selected, _obj[_vm.$style.disabled] = _vm.disabled, _obj ) ],on:{"click":_vm.handleClick}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }